import React from "react";
import { Typography, makeStyles } from "@material-ui/core";

const toneColor = {
  success: "#00d6a4",
  danger: "#ff405d",
  info: "#1ea7ff",
  warning: "#ffa31a",
};

const toneBadge = {
  success: "rgba(0, 214, 164, 0.16)",
  danger: "rgba(255, 64, 93, 0.18)",
  info: "rgba(30, 167, 255, 0.16)",
  warning: "rgba(255, 163, 26, 0.18)",
};

const useStyles = makeStyles((theme) => ({
  card: {
    height: 138,
    borderRadius: 8,
    border: "1px solid #1d3454",
    background: "#111a2b",
    borderTop: ({ tone }) => `2px solid ${toneColor[tone] || toneColor.info}`,
    boxShadow: "0 12px 24px rgba(0, 0, 0, 0.20)",
    padding: theme.spacing(2.25),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    color: "#53647e",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 1,
  },
  value: {
    color: "#f5f7fb",
    fontSize: 31,
    lineHeight: 1,
    fontWeight: 900,
  },
  detail: {
    color: "#b8cdf0",
    fontSize: 12,
    marginTop: theme.spacing(1),
  },
  badge: {
    alignSelf: "flex-start",
    borderRadius: 16,
    color: ({ tone }) => toneColor[tone] || toneColor.info,
    background: ({ tone }) => toneBadge[tone] || toneBadge.info,
    fontSize: 12,
    fontWeight: 800,
    padding: "4px 10px",
  },
}));

const DashboardStatCard = ({ item }) => {
  const classes = useStyles({ tone: item.tone });

  return (
    <div className={classes.card}>
      <div>
        <Typography className={classes.title}>{item.title}</Typography>
        <Typography className={classes.value}>{item.value}</Typography>
        <Typography className={classes.detail}>{item.detail}</Typography>
      </div>
      {item.badge && <span className={classes.badge}>{item.badge}</span>}
    </div>
  );
};

export default DashboardStatCard;
